import {StocksFilter} from "./stocks-filter";
import {CodeName} from "./code-name";
import {TranslateService} from "@ngx-translate/core";
import {Aggregation, AggregationSelector} from "./aggregation-selector";
import {StocksPreset, StocksPresetData} from "./stocks-preset";
import {ElementRef, Renderer2} from "@angular/core";
import {MainHelper} from "../../shared/models/main-helper";

export class StocksHelper extends MainHelper {
    constructor(
    ) {
        super();
    }

    //# check filter, if we need add additional data
    public readonly needGetAdditionalData = (outerFilter: StocksFilter): boolean => {
        let hasData: boolean = false;
        let filter = new StocksFilter();
        for (let param in filter){
            if (filter[param] === null){
                if (outerFilter[param] !== null){
                    hasData = true;
                    break;
                }
            }
        }

        return hasData;
    };

    //# get class for presets in list
    public readonly getClassPresetSelection = (id: number): string => {
        let generalClass = 'preset-main';
        switch (id){
            case 0: return '';
            case 1: return 'orange ' + generalClass;
            case 2: return 'pink ' + generalClass;
            case 3: return 'blue ' + generalClass;
            case 4: return 'green ' + generalClass;
            case 1000: return 'light-green';
            default: return ''
        }
    };

    //# get list if id slickGrid from dataView
    public readonly getRowsIdFromView = (gridView: Slick.Data.DataView<any>): number[] => {
        let items = this.getRowsFromGrid(gridView),
            id: number[] = [],
            hasGroups = items.some(item => item.__group);

        if (hasGroups){
            let itemsInsideGrp: any[] = [];
            items.forEach(item => {
                if (item.__group && item.level === 0){
                    itemsInsideGrp = itemsInsideGrp.concat(item.rows);
                }
            });

            id = itemsInsideGrp.map(item => item.ItemID);
        } else {
            id = items.map(item => item.ItemID);
        }

        if (!id.length){
            id = [];
        }

        return id;
    };

    //# select hidden columns from list of all columns
    public readonly getHiddenColumns = (visible: Slick.Column<any>[], allColumns: Slick.Column<any>[]): Slick.Column<any>[] => {
        return allColumns.filter(item => !visible.some(inItem => item.id === inItem.id));
    };

    //# get preset from list of presets by unique string
    public readonly getCurrentPreset = (presets: StocksPreset[], activePresetGuidName: string): StocksPreset => {
        return presets.find(item => item.presetGuidName === activePresetGuidName);
    };

    //# make copy of the preset
    public readonly copyPreset = (preset: StocksPreset): StocksPreset => {
        let dataPreset = new StocksPresetData( preset.data[0].presetName, preset.data[0].shortPresetName, preset.data[0].description, preset.data[0].counter);
        dataPreset.hotKey = preset.data[0].hotKey;
        dataPreset.uses = preset.data[0].uses;
        dataPreset.groups = preset.data[0].groups;
        dataPreset.aggregations = preset.data[0].aggregations;
        dataPreset.sorting = preset.data[0].sorting;
        return new StocksPreset(preset.presetGuidName, [dataPreset]);
    }

    //# Check if stocks filter is empty
    public readonly stocksFilterEmpty = (filter: StocksFilter): boolean => {
        let newFilter = new StocksFilter(),
            empty: boolean = true;

        for(let prop in newFilter){
            // console.log(typeof newFilter[prop], prop)
            if (JSON.stringify(filter[prop]) === 'undefined'){
                filter[prop] = newFilter[prop]
            }

            // console.log(JSON.stringify(newFilter[prop]) === JSON.stringify(filter[prop]), prop, JSON.stringify(newFilter[prop]), JSON.stringify(filter[prop]))
            !(JSON.stringify(newFilter[prop]) === JSON.stringify(filter[prop])) ? empty = false : null;
        }
        return empty;
    }
}



// WEBPACK FOOTER //
// ./src/app/stocks/models/stocks-helper.ts